/**
 * The App Store / Google Play mark that sits beside a download link.
 *
 * DECORATIVE ON PURPOSE — `alt=""` and `aria-hidden`. Every place this is used already carries
 * the translated label that names the destination (`platforms.ios.action` /
 * `platforms.android.action`), so an alt here would make a screen reader announce the same link
 * twice. It also means the mark needs no dictionary key of its own, in any of the 24 locales.
 *
 * ⚠ THIS IS THE PLAIN PLATFORM MARK, NOT THE OFFICIAL STORE BADGE. The licensed "Download on the
 * App Store" / "Get it on Google Play" lock-ups are still not used anywhere on this page; the
 * artwork is prepared by tools/build-store-icons.mjs from landing/design/markets-icons.
 *
 * The tile's own black background is kept rather than stripped: it is what lets the same file
 * read on the light theme, where a bare white apple glyph would disappear.
 */
export type StorePlatform = "ios" | "android";

const SRC: Record<StorePlatform, string> = {
  ios: "/store/app-store.png",
  android: "/store/google-play.png",
};

export function StoreMark({ platform }: { platform: StorePlatform }) {
  return (
    <img
      className="store-mark"
      src={SRC[platform]}
      // The intrinsic size of the file. The CSS sizes it down; these are here so the line does
      // not reflow when the image arrives.
      width={128}
      height={128}
      alt=""
      aria-hidden="true"
      loading="lazy"
      decoding="async"
    />
  );
}
